<template>
  <v-container fluid class="login-wrapper pa-0 fill-height">
    <v-row class="fill-height ma-0">
      
      <v-col
        cols="12"
        sm="8"
        md="6"
        lg="4"
        class="d-flex justify-center align-center"
      >
        <v-card
          class="pa-8 d-flex flex-column align-center"
          elevation="6"
          width="100%"
          max-width="450"
        >
          <div class="d-flex flex-column align-center">
            <img src="../assets/trevo.png" width="100">
            <h1 style="color: #1F4529;">{{ existentUser ? 'LOGIN' : 'REGISTRE-SE' }}</h1>
          </div>

          <div class="mt-8 w-75" v-if="existentUser">
            <v-select
              v-model="user.user.userId"
              :items="user.lstUsers"
              :item-title="item => item.userName"
              item-value="userId"
              label="Usuário"
              density="compact"
              variant="outlined"
              color="primary"
            />

            <v-text-field
              v-model="password"
              label="Senha"
              density="compact"
              variant="outlined"
              type="password"
              color="primary"
              @keyup.enter="login()"
            />
          </div>

          <div class="mt-8 w-75" v-else>
            <v-text-field
              v-model="user.user.userName"
              label="Usuário"
              density="compact"
              variant="outlined"
              color="primary"
              @keyup.enter="save()"
            />
            <v-text-field
              v-model="user.user.userPassword"
              label="Senha"
              density="compact"
              variant="outlined"
              type="password"
              color="primary"
              @keyup.enter="login()"
            />
          </div>

          <v-btn
            color="#1F4529"
            class="mt-4 w-75"
            @click="existentUser ? login() : save()"
          >
            {{ existentUser ? 'Entrar' : 'Registrar' }}
          </v-btn>

          <p
            class="mt-2 text-red"
            v-if="wrongPassword && existentUser"
          >
            Senha incorreta!
          </p>

          <div class="mt-4">
            <v-btn
              variant="text"
              color="primary"
              class="text-none"
              @click="openForgotPassword()"
              v-if="existentUser"
            >
              Esqueceu a senha?
            </v-btn>
            <forgot-password v-model="showForgotPassword" />
          </div>
        </v-card>
      </v-col>

    </v-row>
  </v-container>
</template>

<script>
import ForgotPassword from './ForgotPassword.vue';

export default {
  data: () => ({
    wrongPassword: false,
    showForgotPassword: false,
    password: '',
    existentUser: false
  }),
  components: {
    ForgotPassword
  },
  computed: {
    user: {
        get() {
            return this.$store.state.user
        },
    },
  },
  methods: {
    async login() {
      const success = await this.$store.dispatch("user/login", this.password)
      if (success) {
        this.$router.push('/')
      } else {
        this.wrongPassword = true
      }
    },
    async save() {
      const success = await this.$store.dispatch("user/insert", this.password)
      if(success) {
        await this.$store.dispatch("user/findAll")
        this.existentUser = true
      }
    },
    openForgotPassword() {
      this.showForgotPassword = true
    }
  },
  async mounted() {
    await this.$store.dispatch("user/findAll")
    this.existentUser = await this.$store.dispatch("user/findExistentUser")
  }
}
</script>

<style>
.login-wrapper {
  background-image: url('@/assets/planta.png');
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  height: 100vh;
}
</style>